<template>
  <section class="portada-clean-wrapper">
    <div class="canvas-clean">
      <!-- NOMBRES PRINCIPALES -->
      <div class="hero-names">
        <span class="sub-tag">DESTINATION WEDDING</span>
        
        <h1 class="main-title">
          <span>{{ firstName }}</span>
          <span class="ampersand">&</span>
          <span>{{ secondName }}</span>
        </h1>
      </div>

      <!-- BLOQUE DE INVITADO, PASES Y MESA (SIN BORDES NI LÍNEAS) -->
      <div 
        v-show="(paquete === 2 || paquete === 3 || paquete === 4) && welcomeText"
        class="guest-clean-block"
      >
        <!-- NOMBRES DEL INVITADO (ENDPOINT) -->
        <div class="guest-names">
          <template v-if="nombresLista.length > 1">
            <div v-for="(n, idx) in nombresLista" :key="idx" class="guest-item">
              {{ n }}
            </div>
          </template>
          <template v-else>
            <span class="single-guest">{{ welcomeText }}</span>
          </template>
        </div>

        <!-- CÁPSULAS FLOTANTES DE PASES Y MESA -->
        <div class="chips-group" v-if="numpase || mesaText">
          <div v-if="(paquete === 3 || paquete === 4) && numpase" class="chip-item">
            <i class="fas fa-ticket-alt"></i>
            <span>{{ numpase }} {{ numpase === 1 ? 'PASAJERO' : 'PASAJEROS' }}</span>
          </div>

          <div v-if="paquete === 4 && mesaText" class="chip-item mesa-item">
            <i class="fas fa-glass-cheers"></i>
            <span>MESA {{ mesaText }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import axios from 'axios'
import baseUrl from '../api'

export default {
  name: 'PortadaNombreYAccesoClean',
  props: {
    firstName:  { type: String, default: 'HERNAN' },
    secondName: { type: String, default: 'ASHLEY' },
    idInvitado: { type: Number, default: null },
    nombre:     { type: String, default: '' },
    idFestejado:{ type: Number, default: null }
  },
  setup(props) {
    const welcomeText = ref('')
    const mesaText = ref('')
    const numpase = ref(null)
    const paquete = ref(null)

    const fetchData = async () => {
      if (!props.idInvitado) return
      try {
        const url = `${baseUrl}/${props.nombre || ''}/${props.idFestejado || ''}/${props.idInvitado}`
        const { data } = await axios.get(url)
        welcomeText.value = data.nombre_mostrar || ''
        mesaText.value = data.num_mesa || ''
        numpase.value = data.num_pase || null
        paquete.value = data.paquete ? Number(data.paquete) : null
      } catch (err) {
        console.error('Error al obtener datos del invitado:', err)
      }
    }

    const nombresLista = computed(() =>
      (welcomeText.value || '').split(',').map(s => s.trim()).filter(Boolean)
    )

    onMounted(fetchData)

    return {
      welcomeText,
      mesaText,
      numpase,
      paquete,
      nombresLista
    }
  }
}
</script>

<style scoped>
/* ESTRUCTURA LIMPIA Y FRESCA */
.portada-clean-wrapper {
  width: 100%;
  padding: 60px 20px;
  background-color: rgba(217, 212, 209, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
}

.canvas-clean {
  width: 100%;
  max-width: 440px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 36px;
}

/* SUBTÍTULO Y NOMBRES PRINCIPALES */
.sub-tag {
  font-family: 'Playfair Display', serif;
  font-size: 11px;
  letter-spacing: 5px;
  color: #8a6a3f;
  text-transform: uppercase;
  margin-bottom: 16px;
  display: block;
  opacity: 0.85;
}

.main-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(34px, 8vw, 46px);
  color: #5c4424;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.15;
  font-weight: 500;
  letter-spacing: 2px;
}

.ampersand {
  font-family: 'Playfair Display', serif;
  font-style: italic;
  font-size: 30px;
  color: #a88758;
  margin: 6px 0;
}

/* SECCIÓN INVITADO LIBRE DE BORDES Y LÍNEAS */
.guest-clean-block {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
}

.guest-names {
  font-family: 'Playfair Display', serif;
  font-size: 22px;
  font-weight: 600;
  color: #70532f;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.guest-item {
  line-height: 1.3;
}

/* CÁPSULAS ELEGANTES DE ACCESO Y MESA */
.chips-group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 4px;
}

.chip-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(8px);
  padding: 8px 18px;
  border-radius: 30px;
  font-family: 'Playfair Display', serif;
  font-size: 11px;
  letter-spacing: 1.5px;
  color: #5c4424;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(138, 106, 63, 0.08);
}

.mesa-item {
  background: rgba(138, 106, 63, 0.12);
  color: #4a361c;
}

.chip-item i {
  font-size: 10px;
  color: #8a6a3f;
}
</style>